InvalidFilterError = require('error-types')

angular.module('rjmNg.services').service('restrictionSetService', [
  "encodedLetterString"
  "stringService"
  "operatorEnums"
  (
    encodedLetterString
    stringService
    operatorEnums
  ) ->

    # NOTE: rjm.util.sequenceStringParser is set here:
    #   Dashboard/public/v2/js/util/sequenceStringParser.js

    restrictionSetService = {}

    _replaceAll = (find, replace, str) ->
      return str.replace(new RegExp(stringService.escapeRegEx(find), 'g'), replace)

    _translateRestrictionSidToColumnId = (restriction) ->
      unless restriction.restrictions?
        if restriction.left.sid?
          restriction.left.column_id = restriction.left.sid
          delete restriction.left.sid
        return

      for r in restriction.restrictions
        _translateRestrictionSidToColumnId(r)

    _translateRestrictionSet = (rset) ->
      result = angular.copy(rset)

      for r in result.restrictions
        _translateRestrictionSidToColumnId(r)

      result

    restrictionSetService.getSidsFromRestrictionSet = (restrictionSet) ->
      translatedRset = _translateRestrictionSet(restrictionSet)
      sids = {}
      for restriction in translatedRset.restrictions
        if restriction.id?
          angular.extend sids, restrictionSetService.getSidsFromRestrictionSet(restriction)
        else
          sids[restriction.left.column_id] = true
      return sids

    restrictionSetService.removeIdentifierFromSequenceString = (stringValue, identifier) ->
      # first, we do the most obvious thing: delete any references to this filter along with
      # the operator that comes immediately before them
      stringValue = stringValue.replace(new RegExp("(AND|OR)[ ]*#{stringService.escapeRegEx(identifier)}", 'g'),"")

      #then, in case that missed one, see if any remain with an operator after them
      stringValue = stringValue.replace(new RegExp("#{stringService.escapeRegEx(identifier)}[ ]*(AND|OR)", 'g'),"")

      #finally, if there is any solo instances of the field left (optionally surrounded by spaces or parentheses), remove them
      stringValue = stringValue.replace(new RegExp("\\(*[ ]*#{stringService.escapeRegEx(identifier)}[ ]*\\)*", 'g'),"")

      stringValue = stringValue.replace(new RegExp("( *AND *)+", 'g')," AND ") #any repeated ands ("[A] AND AND [B]" => "[A] AND [B]")
      stringValue = stringValue.replace(new RegExp("( *OR *)+", 'g')," OR ") #any repeated ors ("[A] OR OR [B]" => "[A] OR [B]")
      stringValue = stringValue.replace(new RegExp("[ ]+", 'g')," ") #boil all multiple spaces down to a single space

      #clean up unnecessary spaces at open or close of parentheses ("( [A])" => "([A])")
      stringValue = stringValue.replace(new RegExp("\\([ ]+", 'g'),"(")
      stringValue = stringValue.replace(new RegExp("[ ]+\\)", 'g'),")")
      stringValue = stringValue.replace(new RegExp("\\(\\)", 'g'),"") #remove any empty parentheses

      stringValue = stringValue.trim()

      return "" if stringValue is "AND"
      return "" if stringValue is "OR"

      return stringValue

    restrictionSetService.flattenRestrictionSet = (restrictionSet) ->
      helper = (string, indexLength, mutator) ->
        for index in [indexLength..0]
          string = encodedLetterString.swapValues(string, index, index + mutator)
        return string

      # replace [ with [[ and ] with ]] in order to distinguish between bracketed identifiers that were there from the beggining vs ones that were replaced
      startingSequenceString = _replaceAll('[',"[[",restrictionSet.sequence.string)
      startingSequenceString = _replaceAll(']',"]]",startingSequenceString)

      newRestrictionSet =
        restrictions: []
        sequence:
          string: startingSequenceString
          syntaxTree: null

      for restriction, i in restrictionSet.restrictions
        currentFilterIdentifier = "["+encodedLetterString.indexToAlpha(i)+"]"
        if restriction.id?
          if restriction.restrictions.length is 0 #skip empty restriction sets and remove the corresponding identifier
            newRestrictionSet.sequence.string = restrictionSetService.removeIdentifierFromSequenceString(newRestrictionSet.sequence.string, currentFilterIdentifier)
            continue
          beforeAddLength = newRestrictionSet.restrictions.length
          newRestrictionSet.restrictions = newRestrictionSet.restrictions.concat restriction.restrictions
          if beforeAddLength > 0
            newString = helper(restriction.sequence.string, restriction.restrictions.length - 1, beforeAddLength)
          else
            newString = restriction.sequence.string
          if restriction.restrictions.length > 1 and restrictionSet.restrictions.length > 1
            newString = "(#{newString})"

          newRestrictionSet.sequence.string = newRestrictionSet.sequence.string.replace currentFilterIdentifier, newString
        else
          newRestrictionSet.restrictions.push restriction
          newRestrictionSet.sequence.string = newRestrictionSet.sequence.string.replace currentFilterIdentifier, encodedLetterString.indexToAlpha(newRestrictionSet.restrictions.length - 1)

      return newRestrictionSet

    restrictionSetService.joinRestrictionSets = (rSetA, rSetB) ->
      # We are not guaranteed that the input rsets will have sid or column_id
      # since that depends on the architecture etc.
      # The translate function will try and rename sid (if present) to column_id
      rSetATranslated = _translateRestrictionSet(rSetA)
      rSetBTranslated = _translateRestrictionSet(rSetB)

      #we have an empty restriction set A
      if rSetATranslated.restrictions.length is 0
        return {
          restrictions: rSetBTranslated.restrictions.splice 0
          sequence:
            string: rSetBTranslated.sequence.string
            syntaxTree: null
        }

      #we have an empty restriction set B
      if rSetBTranslated.restrictions.length is 0
        return {
          restrictions: rSetATranslated.restrictions.splice 0
          sequence:
            string: rSetATranslated.sequence.string
            syntaxTree: null
        }

      newString = rSetBTranslated.sequence.string;

      for index in [(rSetBTranslated.restrictions.length - 1)..0]
        newString = encodedLetterString.swapValues(newString, index, index + rSetATranslated.restrictions.length)

      left = if rSetATranslated.restrictions.length > 1 then "(#{rSetATranslated.sequence.string})" else rSetATranslated.sequence.string
      right = if rSetBTranslated.restrictions.length > 1 then "(#{newString})" else newString

      #join them
      return {
        restrictions: rSetATranslated.restrictions.concat rSetBTranslated.restrictions
        sequence:
          string: "#{left} AND #{right}"
          syntaxTree: null
      }

    # Apply a function to every node, and return a new tree.
    #
    # Note: when functions are passed into this function, the might loose their
    # "this" context.
    mapOverRestrictionsInSyntaxTree = (func, syntaxTree) ->
      # syntaxTree could be either the string (ex. '[A]') or the index (ex. 0).
      unless _(syntaxTree).isObject()
        # If the function you passed in here relies on a particular scope, you might
        # not have it when executed.
        return func(syntaxTree)

      newSyntaxTree =
        leftTree: mapOverRestrictionsInSyntaxTree(func, syntaxTree.leftTree)
        operation: syntaxTree.operation
        rightTree: mapOverRestrictionsInSyntaxTree(func, syntaxTree.rightTree)

      return newSyntaxTree

    # Convert a syntax tree to its string representation
    # (e.g. '([A] AND [B]) OR [C]').
    #
    # The syntaxTree argument may be have either string or numeric leaves.
    restrictionSetService.syntaxTreeToString = (syntaxTree) ->
      unless syntaxTree?
        return null

      if _(syntaxTree).isNumber() or _(syntaxTree.leftTree).isNumber()
        # Convert all indices from numbers to letters
        syntaxTree = mapOverRestrictionsInSyntaxTree(
          encodedLetterString.indexToAlpha
          syntaxTree
        )

      # If the syntax tree has more than one index, convert it to a string;
      # otherwise, just return the single index
      if _(syntaxTree).isObject()
        return "(" +
          restrictionSetService.syntaxTreeToString(syntaxTree.leftTree) +
          " " + syntaxTree.operation + " " +
          restrictionSetService.syntaxTreeToString(syntaxTree.rightTree) +
          ")"
      else
        return syntaxTree

    # Remove all instances of the specified index from the tree.
    #
    # There are four possible tree topologies:
    #
    #   CASE 1: There is only a single restriction in the sequence (e.g. '[A]').
    #     Delete it.
    #
    #   CASE 2: The specified index is on one branch of the tree, and a syntax tree
    #     or restriction is on the other branch. Take the sibling of the branch to
    #     be deleted, and make it the pointer from the parent.
    #
    #     For example, deleting 2 from '2 AND (0 OR 1)' would result in '0 OR 1'.
    #
    #   CASE 3: Both sides of the operation are the same (e.g. '0 AND 0'). This is
    #     pointless, so just delete the tree.
    #
    #   CASE 4: The sequence is empty. Do nothing. (This should never happen.)
    #
    # The tree argument must have numeric leaves.
    cleanTreeRecursive = (tree, index) ->

      # Case 1
      if _(tree).isNumber()
        if tree is index
          return null
        else
          return tree

      # Case 4
      unless tree?
        return null

      # This function is immutable, so build up a new tree instead of modifying the
      # old one.
      newSyntaxTree =
        leftTree: cleanTreeRecursive(tree.leftTree, index)
        operation: tree.operation
        rightTree: cleanTreeRecursive(tree.rightTree, index)

      rightTreeIsNull = _(newSyntaxTree.rightTree).isNull()
      leftTreeIsNull = _(newSyntaxTree.leftTree).isNull()

      # Case 3
      if leftTreeIsNull and rightTreeIsNull
        return null

      # Case 2
      else if leftTreeIsNull and not rightTreeIsNull
        return newSyntaxTree.rightTree
      else if not leftTreeIsNull and rightTreeIsNull
        return newSyntaxTree.leftTree

      else
        return newSyntaxTree

    # Returns a list of the indices used in a syntaxTree.
    #
    # Leaf nodes in syntaxTree argument must be numeric.
    getIndicesUsedInTree = (syntaxTree) ->
      if _(syntaxTree).isNull() or _(syntaxTree).isUndefined()
        return []
      else

        _recur = (syntaxTree) ->
          if _(syntaxTree).isNumber()
            return [syntaxTree]
          array = []
          array.push _recur(syntaxTree.leftTree)
          array.push _recur(syntaxTree.rightTree)
          return _.flatten array

        _recur syntaxTree

    # Returns a syntax tree in which all of the letters (e.g. '[A]') have been
    # converted to indices (e.g. 0 for '[A]').
    restrictionSetService.convertSyntaxTreeLettersToIndex = (syntaxTree) ->
      return null unless syntaxTree?
      mapOverRestrictionsInSyntaxTree encodedLetterString.alphaToIndex, syntaxTree

    # Remove all instances of the specified index from the syntax tree, and
    # decrement any indices greater than index.
    #
    # The syntaxTree argument must use letters as leaves.
    #
    # This function returns a syntax trees which uses indices as leaves.
    restrictionSetService.removeIndexFromSyntaxTree = (syntaxTree, index) ->

      return unless syntaxTree?

      # Make sure we convert the tree from letters to numbers before passing into
      # cleanTreeRecursive
      newTree = cleanTreeRecursive(
        restrictionSetService.convertSyntaxTreeLettersToIndex(syntaxTree), index
      )

      # Iterate over all of the indices, and decrement any index greater than the
      # removed index.
      return mapOverRestrictionsInSyntaxTree((restrictionIndex) ->
        if restrictionIndex > index
          restrictionIndex - 1
        else
          restrictionIndex
      , newTree)

    # Throws an error if a sequence references a restriction which doesn't exist or
    # the sequence does not make include every reference.
    #
    # The leaves in the syntaxTree argument must be numeric.
    restrictionSetService.validateIndicesInTree = (syntaxTree, restrictions) ->
      indexesInTree = getIndicesUsedInTree(syntaxTree)

      for index in indexesInTree
        unless restrictions[index]?
          throw new InvalidFilterError("Filter string references non-existent filter")

      if restrictions.length isnt _.uniq(indexesInTree).length
        throw new InvalidFilterError("Filter string has to reference all filters")

    # Attempt to parse a sequence string.
    #
    # Will throw an error if an error occurs while parsing.
    #
    # Returns a syntaxTree (with letters, converted to upper case,
    # as leaf nodes).
    restrictionSetService.parseSequenceString = (string) ->
      rjm.util.sequenceStringParser.parse(string.toUpperCase())

    # Parse a restrictionSet's sequence.string, verify that the indices
    # contained within the syntax tree are valid, and set the syntaxTree and
    # errorMessage properties of the sequence object accordingly.
    #
    # Will not throw an error, but sets the errorMessage property on the
    # sequence if it is not valid.
    #
    # Note: the set sequence.syntaxTree property has indices as leaf nodes.
    restrictionSetService.validateAndUpdateSyntaxTree = (restrictionSet) ->
      string = restrictionSet.sequence.string

      if (string is null or string.length is 0) and
        restrictionSet.restrictions.length is 0
          restrictionSet.sequence.errorMessage = null
          return

      try
        restrictionSet.sequence.syntaxTree =
          restrictionSetService.convertSyntaxTreeLettersToIndex(
            restrictionSetService.parseSequenceString(string)
          )

        restrictionSetService.validateIndicesInTree(
          restrictionSet.sequence.syntaxTree
          restrictionSet.restrictions
        )

        restrictionSet.sequence.errorMessage = null

      catch error
        if error instanceof InvalidFilterError or
            error instanceof ReferenceError
          restrictionSet.sequence.errorMessage = error.message
        else
          restrictionSet.sequence.errorMessage = "Invalid filter logic"

    # Updates the sequence string to contain another term after a new restriction
    # has been added.
    restrictionSetService.addSequenceTerm = (restrictionSet) ->
      newTerm = encodedLetterString.indexToAlpha(
        restrictionSet.restrictions.length - 1
      )

      if restrictionSet.sequence.string? and
        restrictionSet.sequence.string.length > 0
          restrictionSet.sequence.string += " AND #{newTerm}"
      else
        restrictionSet.sequence.string = newTerm

      restrictionSet.sequence.syntaxTree =
        restrictionSetService.parseSequenceString(restrictionSet.sequence.string)

    # Compare two restriction sets and return whether they are equal.
    restrictionSetService.restrictionSetsAreEqual = (restrictionSet, otherRestrictionSet) ->
      if restrictionSet? isnt otherRestrictionSet? # One is null, the other is non-null
        return false

      if not restrictionSet? # Both are equally null
        return true

      if restrictionSet.sequence?.string?.toUpperCase() isnt
        otherRestrictionSet.sequence?.string?.toUpperCase()
          return false

      if restrictionSet.restrictions.length isnt
        otherRestrictionSet.restrictions.length
          return false

      for restriction, index in restrictionSet.restrictions
        if "#{restriction.left.column_id}" isnt "#{otherRestrictionSet.restrictions[index].left.column_id}" or
          restriction.op isnt otherRestrictionSet.restrictions[index].op or
          not angular.equals(restriction.right, otherRestrictionSet.restrictions[index].right)
            return false

      return true

    # Returns true if the specified item is a filter set (as opposed to a
    # restriction).
    restrictionSetService.isFilterSet = (restriction) ->
      restriction.hasOwnProperty('filter_set_id')

    # Returns a boolean value indicating whether the specified filter set is
    # valid.
    filterSetIsValid = (restriction) ->
      restriction.filter_set_id?

    # Returns a boolean value indicating whether the specified restriction is
    # valid.
    #
    # A restriction is invalid if its right value is null, undefined, empty
    # (in the case of arrays and strings), or, in the case of arrays, contains
    # a null or empty element.
    restrictionIsValid = (restriction) ->
      return false unless restriction.right?

      if restriction.right.length?
        return false unless restriction.right.length > 0

      if restriction.right == "[blank]" and restriction.left.datatype?
        return isValidBlankType(restriction.left.datatype)

      return true unless Array.isArray(restriction.right)

      # We have an array, assert that no [blank]'s are invalid
      for item in restriction.right
        if item == "[blank]" and restriction.left.datatype?
          return false if not isValidBlankType(restriction.left.datatype)

      return restriction.right.some (item) ->
        item? and (not item.length? or item.length > 0)

    # Given a datatype, determine whether or not the datatype allows values
    # of '[blank]' for the right side of the restriction
    isValidBlankType = (datatype) ->
      validBlankTypes = ['TEXT','VARCHAR']
      return validBlankTypes.some (type) ->
          return datatype.match type

    isNumberDataType = (datatype) ->
      validTypes = ['INT','DECIMAL', 'FLOAT', 'DOUBLE', 'NUMERIC']
      return validTypes.some (type) ->
        return datatype.match type

    isStrNumber = (str) ->
      return /^\s*-?\d*\.?\d+$/.test(str)

    isStrNumberForLikeOperator = (str) ->
      return /^-?[\d\%_]*\.?[\d\%_]+$/.test(str)

    # Return whether a restriction set is logically false
    #
    # For now, we will only return true if the sequence is all ANDs and
    # any two or more of the restrictions are setting a single field equal
    # to different values. this can be expanded on later if necessary
    isLogicallyFalse = (restrictionSet) ->
      if restrictionSet.sequence?.string? and !/OR/i.test(restrictionSet.sequence.string)
        temp = {}
        for restriction in restrictionSet.restrictions
          if restriction.op is operatorEnums.SCHEMA_SERVICE_COMPARISON_OPERATOR_IDS["="]
            if temp[restriction.left.column_id]
              if !(restriction.right is temp[restriction.left.column_id])
                return true
            else
              temp[restriction.left.column_id] = restriction.right
      return false

    # Return true if right value exists and it is non empty array or empty string
    restrictionSetService.isRightValueExist = (restriction) ->
      if restriction.right?
        return (Array.isArray(restriction.right) and
          restriction.right.length isnt 0) or
          (typeof restriction.right is "string" and
          restriction.right isnt "")
      else
        return false

    # Validate number value with operators LIKE or NOT LIKE
    validateNumberValueWithLikeOperator = (restriction, indexToAlpha) ->
      if not isStrNumberForLikeOperator(restriction.right)
        restriction.errorMessage = "<strong>Filter #{indexToAlpha}:</strong> The pattern <span class='rj-label--error'>#{restriction.right}</span> cannot be used in the #{operatorEnums.COMPARISON_OPERATOR_SYMBOLS[restriction.op]} clause. Please review."

    # Validate number value with operators IN or NOT IN
    validateNumberValueWithInOperator = (restriction, indexToAlpha) ->
      errorValues = []
      for value in restriction.right
        if !isStrNumber(value)
          errorValues.push(value)
          errorsList = errorValues.join("</span>, <span class='rj-label--error'>")
          values = if errorValues.length is 1 then "value" else "values"
          restriction.errorMessage = "<strong>Filter #{indexToAlpha}:</strong> The non-numeric #{values} <span class='rj-label--error'>#{errorsList}</span> cannot be used in the IN clause. Please review."

    # Validate number value with comparison operators >=, >, <=, <, =, !=
    validateNumberValueWithComparisonOperators = (restriction, indexToAlpha) ->
      if not isStrNumber(restriction.right)
        restriction.errorMessage = "<strong>Filter #{indexToAlpha}:</strong> The numeric field <strong>#{restriction.left.name}</strong> can't be compared to string <span class='rj-label--error'>#{restriction.right}</span>. Please review."

    # Add errorMessage attribute to restriction object if:
    #   - comparing number with a string or with array which contains a string
    restrictionSetService.validateRestriction = (restriction, index) ->

      indexToAlpha = encodedLetterString.indexToAlpha(index)
      restriction.errorMessage = null
      # If the restriction is valid and restriction.right is string or array (not and object!)
      if restrictionSetService.isRightValueExist(restriction) and restriction.op? and restriction.left?.datatype?
        # If left value is a number
        if isNumberDataType(restriction.left.datatype)
          # For operators LIKE or NOT LIKE
          if restriction.op in [operatorEnums.COMPARISON_OPERATOR_IDS['LIKE'], operatorEnums.COMPARISON_OPERATOR_IDS['NOT LIKE']]
            validateNumberValueWithLikeOperator(restriction, indexToAlpha)
          # For operators IN or NOT IN
          else if restriction.op in [operatorEnums.COMPARISON_OPERATOR_IDS['IN'], operatorEnums.COMPARISON_OPERATOR_IDS['NOT IN']]
            validateNumberValueWithInOperator(restriction, indexToAlpha)
          # For operators >=, >, <=, <, =, !=
          else if restriction.op not in [operatorEnums.COMPARISON_OPERATOR_IDS['IS'], operatorEnums.COMPARISON_OPERATOR_IDS['IS NOT']]
            validateNumberValueWithComparisonOperators(restriction, indexToAlpha)

    # Collect all error messages, which restrictionSet has to one attribute errorMessages
    # Those errors use for validation of restrictionSet and showing to user
    consolidateErrorMessages = (restrictionSet) ->
      restrictionSet.errorMessages = []

      if isLogicallyFalse(restrictionSet)
        restrictionSet.errorMessages.push("The filters you have defined are in conflict. Please review.")

      for restriction in restrictionSet.restrictions
        if restriction.errorMessage?
          restrictionSet.errorMessages.push(restriction.errorMessage)

    # Return whether a filter is invalid.
    #
    # Note: this does not actually parse the sequence string or syntaxTree.
    #
    # A filter is invalid if the number of restrictions is greater than zero and
    # either of the following is true:
    # - The errorMessages property of restrictionSet is non-empty
    # - The sequence is null, undefined, or has length zero .
    # - The errorMessage property of the sequence is non-null.
    # - The right property of any of the restrictions is null, undefined, or if
    #   the right property is an array, it has length zero.
    #
    restrictionSetService.restrictionSetIsValid = (restrictionSet) ->
      consolidateErrorMessages(restrictionSet)
      return true unless restrictionSet.restrictions?.length > 0

      return false if restrictionSet.errorMessages.length > 0

      # Determine if the sequence is invalid
      return false if not restrictionSet?.sequence?.string? or
        restrictionSet.sequence.string is '' or
        restrictionSet?.sequence?.errorMessage?

      # Iterate over all of the restrictions and determine if all are valid
      return restrictionSet.restrictions.every (restriction) ->
        if restrictionSetService.isFilterSet(restriction)
          return filterSetIsValid(restriction)
        else
          return restrictionIsValid(restriction)

    return restrictionSetService

  ]
)
